import React from 'react';
import './InfoBlock.scss';
import imgSpacer from 'assets/img/header_image_spacer.gif';
import imgSpacerMobile from 'assets/img/header_image_spacer_mobile.gif';

const InfoBlock = (props) => {

    const [src, updateSrc] = React.useState(null)
    const { data, order } = props;

    const reportWindowSize = React.useCallback(() => {
        if (window.innerWidth > 480) {
            if (data.desktop_image) {
                updateSrc(data.desktop_image)
            }
            else {
                updateSrc(imgSpacer)
            }
        }
        else {
            if (data.desktop_image) {
                updateSrc(data.mobile_image)
            }
            else {
                updateSrc(imgSpacerMobile)
            }
        }
    }, [data]);

    ////////////////////////////////////////////////////

    React.useEffect(() => {
        reportWindowSize()
    }, [reportWindowSize])

    ////////////////////////////////////////////////////

    window.addEventListener('resize', () => {
        window.setTimeout(() => { reportWindowSize() }, 300)
    });

    ////////////////////////////////////////////////////

    // let infoBlockType = data.type;//[text-image-block,image-text-block]
    let infoBlockTypeClasses = ['infoBlock'];

    if (order % 2 === 0) {
        infoBlockTypeClasses.push('text-image-block')
    }
    else {
        infoBlockTypeClasses.push('image-text-block')
    }

    return (
        <div className={infoBlockTypeClasses.join(' ')}>
            <div className="container clearfix">

                <div className="infoBlockText">
                    <div className="infoTextLine1" style={{ color: data.line_1_color }}>{data.line1}</div>
                    <div className="infoTextLine2" style={{ color: data.line_2_color }}>{data.line2}</div>
                    {data.description && <div className="infoTextLine3" dangerouslySetInnerHTML={{ __html: data.description }} />}
                </div>

                <div className="infoBlockImage">
                    <img src={src} alt="" />
                </div>
            </div>

        </div>

    )
}
export default InfoBlock;